import { login, logout, getCurrentUser } from '@/api/auth'
import { getToken, setToken, removeToken, getRefreshToken, setRefreshToken, removeRefreshToken } from '@/utils/auth'

const state = {
  token: getToken() || '',
  refreshToken: getRefreshToken() || '',
  user: null,
  roles: [],
  permissions: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  },
  SET_REFRESH_TOKEN: (state, token) => {
    state.refreshToken = token
    setRefreshToken(token)
  },
  SET_USER: (state, user) => {
    state.user = user
    if (user && user.roles) {
      state.roles = user.roles.map(role => role.code)
      
      // 从角色中提取所有权限编码
      const permissions = new Set()
      user.roles.forEach(role => {
        if (role.permissions && Array.isArray(role.permissions)) {
          role.permissions.forEach(permission => {
            if (permission && permission.code) {
              permissions.add(permission.code)
            }
          })
        }
      })
      state.permissions = Array.from(permissions)
      
      // 调试日志：输出权限信息（开发环境）
      if (process.env.NODE_ENV === 'development') {
        console.log('用户角色:', user.roles)
        console.log('提取的权限编码:', Array.from(permissions))
      }
    } else {
      state.permissions = []
    }
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  }
}

const actions = {
  // 登录
  login({ commit, dispatch }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password })
        .then(response => {
          const { data } = response
          commit('SET_TOKEN', data.accessToken)
          commit('SET_REFRESH_TOKEN', data.refreshToken)
          // 登录接口返回的用户信息可能不包含完整的权限数据，需要重新获取
          // 先设置用户基本信息，然后获取完整信息
          commit('SET_USER', data.user)
          // 立即获取完整的用户信息（包含权限）
          dispatch('getInfo').then(() => {
            resolve()
          }).catch(error => {
            // 即使获取用户信息失败，也允许登录（权限数据可能为空）
            console.warn('获取用户信息失败，但允许登录:', error)
            resolve()
          })
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getCurrentUser()
        .then(response => {
          const { data } = response
          if (!data) {
            reject('验证失败，请重新登录')
          }
          commit('SET_USER', data)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 登出
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit('SET_TOKEN', '')
          commit('SET_REFRESH_TOKEN', '')
          commit('SET_USER', null)
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          removeRefreshToken()
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 重置token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_REFRESH_TOKEN', '')
      commit('SET_USER', null)
      commit('SET_ROLES', [])
      commit('SET_PERMISSIONS', [])
      removeToken()
      removeRefreshToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
